import { debounce } from '../utils/utils';

//polyfill - mostly for custom html solutions
document.querySelectorAll('.qqcTariffs-block .tariffs nav, .qqcTariffsV2-block .tariffs nav, .elab-tariffTable-block .content table tr:first-child').forEach(sticky => sticky.classList.add('sticky'));
document.querySelectorAll('.stickyNavigationTabs-block, .jump-nav-block, .scroll-navigation-block').forEach(sticky => sticky.classList.add('sticky-nav'));

const header = document.getElementById('header');
const navigation = header?.querySelector('.navigation');
const stickies = document.querySelectorAll('.sticky');
const stickyNavs = document.querySelectorAll('.sticky-nav');
const scrollDepthWrappers = document.querySelectorAll('.scroll-depth-wrapper');
const scrollDepthWrapper = scrollDepthWrappers?.[scrollDepthWrappers.length - 1];
const scrollDepthParent = scrollDepthWrapper?.closest('#header') || scrollDepthWrapper?.closest('section');
const scrollDepthWrapperHeight = scrollDepthParent?.id === 'header' ? scrollDepthWrapper.offsetHeight : 0;

if (scrollDepthWrappers.length > 1) {
  scrollDepthWrappers.forEach((wrapper, index) => {
    if (index !== scrollDepthWrappers.length - 1) {
      wrapper.remove();
    }
  });
}

let headerOffsetHeight = header?.offsetHeight || 0;
let lastScrollY = window.scrollY;
let showHeader = true;
let scrollEndTimeOut;
let headerLocked = false;
//how much should be shown when the header is closed

const maxSmMatcher = window.matchMedia('(max-width: 767px)');

if (header) {
  window.addEventListener(
    'resize',
    debounce(() => {
      setOffsets();
    }, 150)
  );
  window.addEventListener('headerSizeChanged', () => {
    setShowHeader(true);
  });
  window.addEventListener('bannerInitialized', () => {
    setOffsets();
  });
}

window.addEventListener('scroll', () => {
  clearTimeout(scrollEndTimeOut);
  scrollEndTimeOut = setTimeout(function () {
    headerLocked = false;
    window.dispatchEvent(new Event('scrollEnd'));
  }, 100);

  if (!document.body.contains(header)) {
    return;
  }

  const scrollY = window.scrollY;
  const scrollDifference = lastScrollY - scrollY;
  const currentShowHeader = scrollY < 300 || Math.abs(scrollDifference) <= 3 ? showHeader : scrollDifference > 0;
  lastScrollY = scrollY;

  if (currentShowHeader && header.classList.contains('banner-shown') && !header.classList.contains('force-hide-banner') && scrollY < headerOffsetHeight * 2.5) {
    header.classList.add('force-hide-banner');
  }

  header.classList.toggle('scrolled', scrollY > 1);

  setShowHeader(currentShowHeader);
});

function setShowHeader(currentShowHeader) {
  if (currentShowHeader === showHeader || headerLocked) {
    return;
  }

  showHeader = currentShowHeader;
  header.classList.toggle('shown', currentShowHeader);

  if (!currentShowHeader && header.classList.contains('banner-shown') && header.classList.contains('force-hide-banner')) {
    header.classList.remove('force-hide-banner');
  }

  if (header.classList.contains('banner-shown')) {
    header.classList.toggle('keep-banner-hidden', lastScrollY < headerOffsetHeight * 5);
  }
}

window.addEventListener('navigationTabFocused', () => {
  setShowHeader(true);
});
window.addEventListener('showHeaderForLink', () => {
  setShowHeader(true);
});

function setOffsets() {
  const navigationOffsetHeight = window.innerWidth >= 992 ? navigation.offsetHeight : 0;
  const bannerOffsetHeight = header.querySelector('.top-banner')?.offsetHeight || 0;

  headerOffsetHeight = header.offsetHeight - scrollDepthWrapperHeight;

  const headerOffset = headerOffsetHeight - navigationOffsetHeight;

  header.style.setProperty('--banner-offset', `-${bannerOffsetHeight}px`);
  header.style.setProperty('--header-offset', `-${headerOffset}px`);
  setStickyOffsets(navigationOffsetHeight, headerOffset, bannerOffsetHeight);

  requestAnimationFrame(() => {
    header.classList.add('header-offsets-initialized');
    [...stickyNavs, ...stickies].forEach(sticky => sticky.classList.add('sticky-offsets-initialized'));
  });

  main.style = `--body-offset: ${header.offsetHeight - bannerOffsetHeight}px;`;
}

function setStickyOffsets(stickyBaseOffset, headerOffset, bannerOffset) {
  let stickyOffset = stickyBaseOffset;

  stickyNavs.forEach(sticky => {
    setStickyOffsetAttributes(sticky, stickyOffset, headerOffset, bannerOffset);
    stickyOffset += sticky.offsetHeight;
  });
  stickies.forEach(sticky => {
    setStickyOffsetAttributes(sticky, stickyOffset, headerOffset, bannerOffset);
  });
}

function setStickyOffsetAttributes(stickyElement, offset, headerOffset, bannerOffset) {
  stickyElement.style.setProperty('--banner-shown-offset', `calc(${offset + headerOffset}px + var(--sticky-offset, 0px))`);
  stickyElement.style.setProperty('--header-shown-offset', `calc(${offset + headerOffset - bannerOffset}px + var(--sticky-offset, 0px))`);
  stickyElement.style.setProperty('--header-hidden-offset', `calc(${offset}px + var(--sticky-offset, 0px))`);
}

const scrollToTarget = (target, { offset, onScrollEnd } = {}) => {
  setShowHeader(true);
  headerLocked = true;
  if (!target) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    let stickyOffset = 0;
    stickyNavs.forEach(sticky => {
      stickyOffset += sticky.offsetHeight;
    });

    // GET PADDING OF TARGET ELEMENT
    const compStyles = window.getComputedStyle(target);

    const paddingTop = parseInt(compStyles.paddingTop.split('px')[0]);

    // SET ABSOLUTE SCROLL OFFSET IF GIVEN
    const scrollOffset = offset?.dataset?.scrollOffset ? parseInt(offset.dataset.scrollOffset) : 0;

    // ADD OFFSET TOP IF NO PADDING IS GIVEN OR ELEMENT HAS NO HEIGHT SO INTENTIONAL ANCHOR
    const paddingTopOffset = paddingTop || target?.offsetHeight === 0 || target?.classList.contains('stickyNavigationTabsStart-block') ? 0 : 32;

    // CALCULATE ADDITIONAL OFFSET BASED ON SCROLL MINIMAL ATTRIBUTE
    let additionalOffset = 0;

    function getAdditionalOffset(desiredOffset) {
      if (paddingTopOffset === 0) {
        return paddingTop > desiredOffset ? desiredOffset - paddingTop : -(paddingTop - desiredOffset);
      } else {
        return desiredOffset > paddingTopOffset ? desiredOffset - paddingTopOffset : -(paddingTopOffset - desiredOffset);
      }
    }

    if (maxSmMatcher.matches && offset?.hasAttribute('data-scroll-minimal-mobile')) {
      additionalOffset = getAdditionalOffset(32);
    } else if (offset?.hasAttribute('data-scroll-minimal-desktop')) {
      additionalOffset = getAdditionalOffset(48);
    }

    // CALCULATE FINAL OFFSET
    const topOffset = headerOffsetHeight + stickyOffset + paddingTopOffset + scrollOffset + additionalOffset;

    window.scrollTo({
      top: target.getBoundingClientRect().top - document.body.getBoundingClientRect().top - topOffset,
      behavior: 'smooth'
    });
  }
  window.dispatchEvent(new Event('scrollStart'));
  if (onScrollEnd) {
    window.addEventListener('scrollEnd', onScrollEnd, { once: true });
  }
};
window.scrollToTarget = scrollToTarget;

window.dispatchEvent(new Event('scroll'));

document
  .querySelectorAll(
    '#header .navigation .action .buttons a[href^="#"], #header .navigation nav.hide--lg a[href^="#"].cta-mobile, section:not(.stickyNavigationTabs-block) [rel="scroll:to"]:not([data-scroll-to]), section:not(.stickyNavigationTabs-block) a[href^="#"]:not([data-scroll-to])'
  )
  .forEach(scrollTrigger => {
    scrollTrigger.addEventListener('click', ev => {
      ev.preventDefault();
      const targetId = scrollTrigger.href.split('#')[1];
      if (!targetId) {
        return;
      }

      const target = document.getElementById(targetId);
      if (!target) {
        return;
      }

      scrollToTarget(target, { offset: scrollTrigger });
    });
  });

document.querySelectorAll('[data-jump]').forEach(scrollTrigger => {
  scrollTrigger.addEventListener(
    'click',
    ev => {
      ev.stopPropagation();
      const target = document.querySelector(scrollTrigger.dataset.jump);
      if (target) {
        scrollToTarget(target, { offset: scrollTrigger });
      }
    },
    { capture: true }
  );
});

if (scrollDepthWrapper) {
  const scrollDepthBar = scrollDepthWrapper.querySelector('.scroll-depth-bar');
  const hero = document.querySelector('section[class*="hero"]');

  if (hero) {
    const heroIntersectionObserver = new IntersectionObserver(entries => {
      scrollDepthParent.classList.toggle('show-scroll-depth', !entries[0].isIntersecting);
    });
    heroIntersectionObserver.observe(hero);
  }

  document.addEventListener('scroll', () => {
    const barWidth = (window.scrollY / (document.body.offsetHeight - window.innerHeight)) * 100;
    scrollDepthBar.style.width = `${barWidth}%`;
    scrollDepthBar.classList.toggle('full-width', barWidth >= 99.95);
  });
}
